import { render, staticRenderFns } from "./DispensingDeniedComponent.vue?vue&type=template&id=2a3d99da"
import script from "./DispensingDeniedComponent.vue?vue&type=script&lang=js"
export * from "./DispensingDeniedComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports